import {Badge} from "@mantine/core";
import {readLocalStorageValue} from "@mantine/hooks";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../../app/hooks";
import {ChatEngine, HasEditorPrivileges, LocalStorageKeys} from "../../../types";
import IconSparkles from "../../../assets/sparkles.svg?react";
import {useRoleProtection} from "./RoleProtection";

export function ExperimentalEngineIndicator() {
    const {t} = useTranslation();
    const chatEngine = useAppSelector((state) => state.session.chosenChatEngine);
    const hasAccess = useRoleProtection(HasEditorPrivileges);
    const showDebugIndicators = readLocalStorageValue({
        key: LocalStorageKeys.ShowDebugIndicators,
        defaultValue: false,
    });

    if (!hasAccess || chatEngine !== ChatEngine.Experimental) {
        return null;
    }

    return (
        <Badge
            leftSection={<IconSparkles width={14} height={14} />}
            variant="light"
            color="grape"
            size="sm"
            style={
                showDebugIndicators
                    ? {
                          outline: "2px dashed var(--mantine-color-grape-5)",
                          outlineOffset: "2px",
                      }
                    : undefined
            }
        >
            {t("chat.experimentalEngineActive")}
        </Badge>
    );
}
